import useAuthStore from "@/context/auth/useAuthStore";
import useSuperAdminStore from "@/context/superadmin/useSuperAdminStore";
import { USER_ROLES } from "@/constants/auth";
export function useEffectiveCustomerId() {
    const { userRole, customerIdentifier } = useAuthStore();
    const { selectedCustomerId } = useSuperAdminStore();
    const isSuperAdmin = userRole === USER_ROLES.SUPERADMIN;
    const isViewingAllOrgs = isSuperAdmin && selectedCustomerId === null;
    const hasResolvedCustomerSelection = !isSuperAdmin || selectedCustomerId !== undefined;
    const effectiveCustomerId = isSuperAdmin ? selectedCustomerId === null ? undefined : selectedCustomerId || undefined : customerIdentifier || undefined;
    const isViewingOwnOrg = !isSuperAdmin || selectedCustomerId === undefined || selectedCustomerId === null || selectedCustomerId === customerIdentifier;
    return {
        userRole,
        isSuperAdmin,
        selectedCustomerId,
        customerIdentifier,
        effectiveCustomerId,
        isViewingAllOrgs,
        isViewingOwnOrg,
        hasResolvedCustomerSelection
    };
}
export default useEffectiveCustomerId;
